import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import { api } from "../api";
import { API_PATH, MODULE_LOGICS } from "../constants";

export const SET_LOADING = "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_LOADING";
export const SET_MODULE_LOGIC = "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_MODULE_LOGIC";

export const SET_FILTERS_DIRTY =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_FILTERS_DIRTY";
export const SET_UPDATES_LOADING =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_UPDATES_LOADING";
export const SET_PRICING_OPTIONS_LOADING =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_PRICING_OPTIONS_LOADING";
export const SET_CATEGORIES_LOADING =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/SET_CATEGORIES_LOADING";

export const FETCH_CURRENT_USER =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_TABLE_SUCCESS =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/FETCH_TABLE_SUCCESS";
export const FETCH_FILTERS_SUCCESS =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/FETCH_FILTERS_SUCCESS";

export const UPDATE_FILTERS = "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_FILTERS";
export const UPDATE_MEMBER_STATUSES =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_MEMBER_STATUSES";
export const UPDATE_CHART = "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_CHART";
export const UPDATE_MODULE_LOGIC =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_MODULE_LOGIC";
export const UPDATE_CATEGORIES =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_CATEGORIES";
export const UPDATE_PRICING_OPTIONS =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_PRICING_OPTIONS";
export const UPDATE_CATEGORIES_SELECTED =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_CATEGORIES_SELECTED";
export const UPDATE_PRICING_OPTIONS_SELECTED =
  "./membershipLengthByAgreement/MEMBERSHIP_LENGTH/UPDATE_PRICING_OPTIONS_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateFilters: createAction(UPDATE_FILTERS),
  updateCategories: createAction(UPDATE_CATEGORIES),
  updatePricingOptions: createAction(UPDATE_PRICING_OPTIONS),
  changeModuleLogic: createAction(UPDATE_MODULE_LOGIC),
  updateData: createAction(UPDATE_CHART)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, fetchChartData);
  yield takeLatest(UPDATE_PRICING_OPTIONS, updatePricingOptions);
  yield takeLatest(UPDATE_CATEGORIES, updateCategories);
  yield takeLatest(UPDATE_MODULE_LOGIC, switchModuleLogic);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_LOADING, payload: true });

  try {
    yield fetchFilters();
    yield fetchChartData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* switchModuleLogic({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_MODULE_LOGIC, payload });

  try {
    yield fetchFilters();
    yield fetchChartData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchChartData() {
  const { organization_id, short_url, date, moduleLogic } = yield getCommonApiParams();
  const filters = yield getFiltersByModuleLogic(moduleLogic);

  const params = {
    organization_id,
    short_url,
    date,
    ...filters
  };

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  try {
    const { data: tableData } = yield call(
      api.getTable,
      API_PATH[moduleLogic],
      moduleLogic,
      params
    );

    yield put({
      type: FETCH_TABLE_SUCCESS,
      payload: tableData
    });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* fetchFilters() {
  const { organization_id, short_url, date, moduleLogic } = yield getCommonApiParams();
  const params = {
    organization_id,
    short_url,
    date
  };

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    const { data } = yield call(api.getFilters, API_PATH[moduleLogic], params);

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* updateCategories({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_CATEGORIES_SELECTED, payload });

  yield updateFilters("categories", payload);
}

function* updatePricingOptions({ payload }) {
  const { useSecondaryCategories } = yield select((state) => state.commonReducer.commonProps);

  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRICING_OPTIONS_SELECTED, payload });

  if (useSecondaryCategories) {
    yield updateFilters("pricing_options", payload);
  }
}

export function* updateFilters(name, payload) {
  const values = payload.map((p) => p.id).join(",");

  if (name === "categories") {
    yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: true });
    yield getRevenueCategories(false, values);
  }
  if (name === "pricing_options") {
    yield put({ type: SET_CATEGORIES_LOADING, payload: true });
    yield getRevenueCategories(true, values);
  }
}

function* getRevenueCategories(isPricingOption, categoryValues) {
  const { organization_id, short_url, date } = yield getCommonApiParams();
  const params = {
    organization_id,
    short_url,
    date,
    [isPricingOption ? "pricing_options" : "categories"]: categoryValues
  };

  try {
    const { data } = yield call(api.getRevenueCategories, "by_agreements", params);

    if (isPricingOption) {
      yield put({ type: SET_CATEGORIES_LOADING, payload: false });
      yield put({
        type: UPDATE_CATEGORIES_SELECTED,
        payload: data.categories
      });
    } else {
      yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: false });
      yield put({
        type: UPDATE_PRICING_OPTIONS_SELECTED,
        payload: data.pricing_options
      });
    }
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const {
    currentUser: { calendarEndDate },
    selectedModuleLogic
  } = yield select((state) => state.membershipLengthByAgreement);

  return {
    organization_id: organization_id.toString(),
    short_url,
    date: calendarEndDate,
    moduleLogic: selectedModuleLogic.id
  };
}

function* getFiltersByModuleLogic(moduleLogic) {
  if (moduleLogic === MODULE_LOGICS.MEMBERS) {
    const member_status = yield select(
      (state) => state.membershipLengthByAgreement.selectedFilters.member_status.id
    );
    return {
      member_status
    };
  }

  const { agreement_status, pricing_options, group_by, categories, membership_types, type } =
    yield select((state) => state.membershipLengthByAgreement.selectedFilters);

  return {
    agreement_status: agreement_status.id,
    categories,
    type: type.id,
    ...(type.id === "membership_type"
      ? { membership_types: membership_types.map((obj) => obj.id).join(",") }
      : {
          pricing_options: pricing_options.map((obj) => obj.id).join(","),
          group_by: group_by.id
        })
  };
}
